import { Card, Grid, Paper } from '@mui/material';
import * as React from 'react';
import { Modal } from '../../components';
import ReservationUsedBlocks from '../../components/ReservationUsedBlocks';
import CalendarReservas from './components/CalendarReservas';
import FormReserva from './components/FormReservas';

const PanelReservasView = () => {
  React.useEffect(() => {}, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [refresh, setRefresh] = React.useState(false);
  const [areaIds, setAreaIds] = React.useState([]);
  const [dates, setDates] = React.useState([]);
  const [userCodeId, setUserCodeId] = React.useState(null);
  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isCalendar, setIsCalendar] = React.useState(false);

  return (
    <Grid container spacing={2} sx={{ marginTop: '1px' }}>
      <Grid item md={4}>
        <Card>
          <FormReserva
            setOpenModalForm={(val) => {}}
            // params={reservasStore.params}
            onRefresh={() => {
              setRefresh(true);
              setTimeout(() => {
                setRefresh(false);
              }, 100);
            }}
            onChangeAreas={(val) => setAreaIds(val)}
            onChangeDates={(val) => setDates(val)}
            onChangeUserCodeId={(val) => setUserCodeId(val)}
            setIsCalendar={(val) => setIsCalendar(val)}
          />
        </Card>
      </Grid>
      <Grid item md={8}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Grid container>
            {isCalendar ? (
              <CalendarReservas
                areaIds={areaIds}
                dates={dates}
                refresh={refresh}
                userCodeId={userCodeId}
              />
            ) : (
              <ReservationUsedBlocks
                areaIds={areaIds}
                dates={dates}
                refresh={refresh}
                userCodeId={userCodeId}
              />
            )}
          </Grid>
        </Paper>
      </Grid>
      <Modal
        id="modalFormAreas"
        title="Nueva reserva"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      ></Modal>
    </Grid>
  );
};

export default PanelReservasView;
